module.exports = __webpack_public_path__ + "img/组 7016@3x.78546088.png";